import { useContext, useEffect, useRef } from "react";
import { Box, Tabs, Tab, Stack, Button } from "@mui/material";
import { MainInformation } from './MainInformation';
import { PropertyImages } from './PropertyImages';
import { PropertyLocation } from './PropertyLocation';
import { OtherInformation } from './OtherInformation';
import { ToolContext } from "../../../../../core/context/ToolContext";
import { rqx } from "../../../../../core/request/API";
import { env } from "../../../../../core/Env";
import { TxtEmail } from "../../../../../core/global/Format";
import { validateMobile, ValidUrl } from "../../../../../core/validator/Validator";
import { Confirmation } from "../../../../../core/global/Confirmation";
import { InputsErrMsg } from "../../../../../core/global/InputErrMsg";
import { S3 } from "../../../../../core/transmit/S3";
import { SnakeLoader } from "../../../../../core/loader/SnakeLoader";
import { SuccessMsg } from "../../../../../core/global/SuccessMsg";

export const Form = ({ company_id, user_id }) => {
    const { realproperty_state } = useContext(ToolContext);
    const { dataLocations, mainInfrmtn, dfltMainInfrmtn, confirmation, otherInfrmtn, dfltOtherInfrmtn, myPrptyLstngs } = realproperty_state;
    const method = new URLSearchParams(window.location.search).get('method');
    const list_id = Number(window.atob(new URLSearchParams(window.location.search).get('id')).replace('prm_', ''));
    const refs = {
        'main-information': useRef(null),
        'property-images': useRef(null),
        'property-location': useRef(null),
        'other-information': useRef(null),
    };

    const __init = async () => {
        confirmation.set((p) => ({...p, loader: true}))
        try {
            const res_attach = await rqx.get(`<<tool>>/${env()}/propertyListing/attactment`, { id: list_id })
            const res_data = await rqx.get(`<<tool>>/${env()}/propertyListing/read_spcfc_list`, { company_id: company_id, id: list_id})
            if (res_attach && res_data?.length && method === 'update') {
                const data = res_data[0];
                const arrayOfObjects = typeof JSON.parse(data.indoor_facilities)[0] === 'object';
                const li = JSON.parse(data.listing_information);
                const pr = JSON.parse(data.price);
                getProvCity('province', data.province_id);
                getProvCity('city', data.city_id);
                mainInfrmtn.set((p) => ({
                    ...p,
                    listingTitle: { ...mainInfrmtn.data.listingTitle, value: data.name },
                    description: data.description,
                    ownerType: { ...mainInfrmtn.data.ownerType, value: 1 },
                    offerType: { ...mainInfrmtn.data.offerType, value: data.offer_type },
                    propertyType: { ...mainInfrmtn.data.propertyType, value: data.property_type_id },
                    subType: { ...mainInfrmtn.data.subType, value: data.property_subtype_id },
                    condominiumName: li.condo_name,
                    subdivisionName: li.subdivision_name,
                    buildingName: li.building_name,
                    unitNoFloorNo: li.un_with_fn,
                    blockLotUnitFloorNo: li.baluf_number,
                    bedroom: li.bedroom,
                    bathroom: li.bath_room,
                    floorArea: li.floor_area,
                    landSize: li.land_size,
                    forClosure: data.foreclosure,
                    preSelling: data.pre_selling,
                    price: { ...mainInfrmtn.data.price, value: pr.price || "" },
                    monthly: { ...mainInfrmtn.data.monthly, value: pr.monthly || "" },
                    yearly: { ...mainInfrmtn.data.yearly, value: pr.yearly || "" },
                    showPrice: data.show_price, 
                    availableFrom: { ...mainInfrmtn.data.availableFrom, value: data.available_date },
                }))
                otherInfrmtn.set((p) => ({
                    ...p,
                    listing_contact_id: data.contact_id,
                    lastName: { ...otherInfrmtn.data.lastName, value: data.last_name },
                    firstName: { ...otherInfrmtn.data.firstName, value: data.first_name },
                    mobileNumber: { ...otherInfrmtn.data.mobileNumber, value: data.phone_number },
                    email: { ...otherInfrmtn.data.email, value: data.email },
                    province: { ...otherInfrmtn.data.province, value: data.province_id },
                    city: { ...otherInfrmtn.data.city, value: data.city_id },
                    barangay: { ...otherInfrmtn.data.barangay, value: data.barangay_id || ''},
                    streetNumber: data.street_building_number,
                    indoorFacilities: { ...otherInfrmtn.data.indoorFacilities, 
                        value: arrayOfObjects ? JSON.parse(data.indoor_facilities).map(v => v.id) : JSON.parse(data.indoor_facilities),
                    },
                    outdoorFacilities:  { ...otherInfrmtn.data.outdoorFacilities, 
                        value: arrayOfObjects ? JSON.parse(data.outdoor_facilities).map(v => v.id) : JSON.parse(data.outdoor_facilities),
                    },
                    youtubeLink: { ...otherInfrmtn.data.youtubeLink, value: res_attach[0].youtube_link },
                    photos: res_attach,
                    checkList: JSON.parse(data.property_checklist),
                }))
            }
            confirmation.set((p) => ({...p, loader: false}))
        } catch (err) {
            console.error("Failed to fetch data", err);
        }
    }

    const handleChange = (e, type) => {
        const { name, value } = e.target;
        getProvCity(name, value);
        if (["listingTitle", "price", "monthly", "yearly", "availableFrom", "province", "city", "barangay", "firstName", "lastName", "email", "mobileNumber"].includes(name)) {
            const isValid = value !== "";
            type.set((p) => ({
                ...p,
                [name]: { 
                ...p[name],
                    value,
                    stat: name === "email" ? !TxtEmail(value) : name === "mobileNumber" ? !validateMobile(value) : !isValid },
                ...(name === "province" && {
                    city: { ...type.data.city, value: "" },
                }),
                ...((name === "province" || name === "city") && { barangay: { ...type.data.barangay, value: "" },
                }),
            }))
            return;
        }
        type.set((p) => ({ ...p, [name]: value }))
    }
    // function to get city and province
    const getProvCity = async ( name, value ) => {
        if (name === "province") {
            const res_cities = await rqx.get(`<<global>>/${env()}/location/city`, { ref: "province_id", filter: JSON.stringify([value]) });
            dataLocations.set((p) => ({
                ...p,
                cities: res_cities || [],
            }));
        }
        if (name === "city") {
            const res_barangays = await rqx.get(`<<global>>/${env()}/location/barangay`, { ref: "city_id", filter: JSON.stringify([value]) });
            dataLocations.set((p) => ({
                ...p,
                barangays: res_barangays || [],
            }));
        } 
    }

    const isInputsInvalid = () => {
        const mainFormInputs = Object.entries(mainInfrmtn.data).filter(([k, v]) => k !== 'property_seller_information' && typeof v === "object" && v !== null && !Array.isArray(v) && (mainInfrmtn.data.offerType.value === 1 ? k !== "monthly" && k !== "yearly" : k !== "price")).map(([k, v]) => {
            if (k === "listingTitle" || k === "monthly" || k === "yearly" || k === "price" || k === "availableFrom") {
                const val = typeof v?.value === 'number' ? v.value.toString() : v?.value ?? "";
                v.msg = !val.trim() ? dfltMainInfrmtn.data[k].msg : "";
                v.stat = !val.trim();
            } else {
                v.msg = v.value ? "" : dfltMainInfrmtn.data[k].msg;
                v.stat = !v?.value;
            }
            return v;
        })
        const hasExistingPhoto = otherInfrmtn.data.photos.filter(v => v.photo_type === 1).some(v => v.active === 1 && v.data_status === 'InUse');
        const otherFormInputs = Object.entries(otherInfrmtn.data).filter(([_, v]) => typeof v === "object" && v !== null && !Array.isArray(v)).map(([k, v]) => {
            if (k === "lastName" || k === "firstName") {
                v.msg = !v?.value.trim() ? dfltOtherInfrmtn.data[k].msg : "";
                v.stat = !v?.value.trim();
            } else if (k === "email") {
                v.msg = !TxtEmail(v.value) ? dfltOtherInfrmtn.data[k].msg : "";
                v.stat = !TxtEmail(v.value);
            } else if (k === "mobileNumber") {
                v.msg = !validateMobile(v.value) ? dfltOtherInfrmtn.data[k].msg : "";
                v.stat = !validateMobile(v.value);
            } else if (k === "province" || k === "city") {
                v.msg = v.value ? "" : dfltOtherInfrmtn.data[k].msg;
                v.stat = !v?.value;
            } else if (method === 'create' && k === "propertyCoverPhoto") {
                v.msg = v.b64Img ? "" : dfltOtherInfrmtn.data[k].msg;
                v.stat = !v.b64Img;
            } else if (k === "morePhotos") {
                v.msg = (v.b64Imgs.length > 0 || hasExistingPhoto) ? "" : dfltOtherInfrmtn.data[k].msg;
                v.stat = !(v.b64Imgs.length > 0 || hasExistingPhoto); 
            } else if (k === "youtubeLink") {
                v.msg = !v?.value.trim() ? "" : !ValidUrl(v.value) ? dfltOtherInfrmtn.data[k].msg : "";
                v.stat = !v?.value.trim() ? false : !ValidUrl(v.value) ? true : false;
            }
            return v;
        })
        if ([...mainFormInputs, ...otherFormInputs].some((v) => v.stat)) {
            confirmation.set((p) => ({
                ...p, hasInvalidInputs: true,
            }))
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {
        myPrptyLstngs.set(p => ({ ...p, loader: true }))
        try {
            let final_photos = [];
            if ( method === 'update' ) {
                // existing more photos new details with updated cover photo
                let exstngPht = [];
                if (otherInfrmtn.data.propertyCoverPhoto.b64Img) {
                    const coverPhotoId = otherInfrmtn.data.photos.find(v => v.photo_type === 2)?.id;
                    const getLink = await S3(otherInfrmtn.data.propertyCoverPhoto.objectImg);
                    const updatedPhotos = otherInfrmtn.data.photos.map(photo =>
                        photo.id === coverPhotoId ? 
                            { ...photo, 
                                link: getLink.location, 
                                name: otherInfrmtn.data.propertyCoverPhoto.name, 
                                size: otherInfrmtn.data.propertyCoverPhoto.size, 
                                type: otherInfrmtn.data.propertyCoverPhoto.type }
                            : photo
                    );
                    otherInfrmtn.set((p) => ({
                        ...p,
                        photos: updatedPhotos
                    }));
                    exstngPht = updatedPhotos;
                }
                // check if cover photo is changing
                let morePhotos = [];
                if (otherInfrmtn.data.morePhotos.b64Imgs.length > 0) {
                    morePhotos = await Promise.all (
                        otherInfrmtn.data.morePhotos.imgProperties.map(async (v) => {
                            const getLink = await S3(v.objectImg);
                            const { objectImg, ...p } = v;
                            return {
                                ...p,
                                link: getLink.location,
                                youtube_link: otherInfrmtn.data.youtubeLink.value,
                                id: "",
                                // MODIFY THIS LISTING_ID TO REAL ID
                                listing_id: list_id
                            };
                        })
                    )
                }
                final_photos = [...(exstngPht.length === 0 ? otherInfrmtn.data.photos : exstngPht), ...morePhotos];
            } else if ( method === 'create' ) {
                //merging more photos and cover photo
                const { name, size, type, link, photo_type, objectImg } = otherInfrmtn.data.propertyCoverPhoto; 
                const mergePhotos = [...otherInfrmtn.data.morePhotos.imgProperties.map(v => ({ ...v })), { link, name, size, type, photo_type, objectImg }];
                // to get only the needed property key for photo (file_name, file_size, file_type, link, photo_type, youtube_link)
                final_photos = await Promise.all (
                    mergePhotos.map(async (v) => {
                        const getLink = await S3(v.objectImg);
                        // to exclude the "file" property key
                        const { objectImg, ...p } = v;
                        return { ...p, link: getLink.location, youtube_link: otherInfrmtn.data.youtubeLink.value};
                    })
                )
            }
            const body = {
                id: list_id,
                companyId: company_id,
                userId: user_id,
                status: 1,
                listing_contact_id: otherInfrmtn.data.listing_contact_id, 
                ownerType: 1, 
                offerType: mainInfrmtn.data.offerType.value, 
                propertyType: mainInfrmtn.data.propertyType.value, 
                subType: mainInfrmtn.data.subType.value, 
                listing_information: { 
                    bedroom: mainInfrmtn.data.bedroom,
                    bath_room: mainInfrmtn.data.bathroom,
                    land_size: mainInfrmtn.data.landSize,
                    condo_name: mainInfrmtn.data.condominiumName,
                    floor_area: mainInfrmtn.data.floorArea,
                    un_with_fn: mainInfrmtn.data.unitNoFloorNo,
                    baluf_number: mainInfrmtn.data.blockLotUnitFloorNo,
                    building_name: mainInfrmtn.data.buildingName,
                    subdivision_name: mainInfrmtn.data.subdivisionName,
                },
                forClosure: mainInfrmtn.data.forClosure,
                preSelling: mainInfrmtn.data.preSelling, 
                price:  mainInfrmtn.data.price.value === "" 
                    ? { yearly: mainInfrmtn.data.yearly.value, monthly: mainInfrmtn.data.monthly.value }
                    : { price: mainInfrmtn.data.price.value },
                showPrice: mainInfrmtn.data.showPrice, 
                availableFrom: mainInfrmtn.data.availableFrom.value, 
                listingTitle: mainInfrmtn.data.listingTitle.value, 
                description: mainInfrmtn.data.description,
                first_name: otherInfrmtn.data.firstName.value, 
                last_name: otherInfrmtn.data.lastName.value, 
                email: otherInfrmtn.data.email.value, 
                mobile_number: otherInfrmtn.data.mobileNumber.value, 
                province: otherInfrmtn.data.province.value, 
                city: otherInfrmtn.data.city.value, 
                barangay: otherInfrmtn.data.barangay.value || 0, 
                streetNumber: otherInfrmtn.data.streetNumber, 
                indoorFacilities: otherInfrmtn.data.indoorFacilities.value, 
                outdoorFacilities: otherInfrmtn.data.outdoorFacilities.value, 
                youtube_link: otherInfrmtn.data.youtubeLink.value, 
                photos: final_photos,
                checkList: otherInfrmtn.data.checkList, 
            }
            const res = await rqx.post(`<<tool>>/${env()}/propertyListing/${method}_my_property`, body)
            if (res.message === 'success') {
                myPrptyLstngs.set(p => ({ ...p, success: true }))
                setTimeout(() => {
                    window.location.href = '/realproperty/property-listing';
                }, 1500);
            }
        } catch (err) {
            console.error("Failed to submit data", err);
        }
       
    }

    const handleModal = (v) => {
        isInputsInvalid() && myPrptyLstngs.set(p => ({ ...p, modal: v === 'open' }))
    }

    const handleTabChange = (_, newVal) => {
        const sectionRef = refs[newVal];
        if (sectionRef?.current) {
            sectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    useEffect(() => { 
        method === 'update' && __init();
        // eslint-disable-next-line
    }, [])

    return (
        <Box>
            { method === 'update' && confirmation.data.loader ? 
                <Box display="flex" justifyContent="center" mt="4rem"><SnakeLoader size="12px" bg="#11783C" distance="8px" /></Box>
            : 
                <>
                    <Tabs value={'main-information'} onChange={handleTabChange} sx={{ my: "1rem" }}>
                        <Tab label="Main Information" value='main-information'/>
                        <Tab label="Property Images" value='property-images'/>
                        <Tab label="Property Location" value='property-location'/>
                        <Tab label="Other Information" value='other-information'/>
                    </Tabs>
                    <Box ref={refs['main-information']}>
                        <MainInformation handleChange={handleChange} />
                    </Box>
                    <Box ref={refs['property-images']} sx={{ pt: "1rem" }}>
                        <PropertyImages />
                    </Box>
                    <Box ref={refs['property-location']} sx={{ pt: "1rem" }}>
                        <PropertyLocation handleChange={handleChange} method={method}/>
                    </Box>
                    <Box ref={refs['other-information']} sx={{ pt: "1rem" }}>
                        <OtherInformation handleChange={handleChange} />
                    </Box>
                    <Stack my="2rem" flexDirection="row" justifyContent="center" gap="5rem">
                        <Button variant="outlined" size="large" color="error" sx={{ width: "10rem" }}> Cancel </Button>
                        <Button variant="contained" size="large" sx={{ width: "10rem"}} onClick={() => handleModal('open')}> { method === 'create' ? 'Save' : 'Update'} </Button>
                    </Stack>
                    { myPrptyLstngs.data.modal && <Confirmation isOpen={myPrptyLstngs.data.modal} cancel={() => handleModal('close')} send={() => handleSubmit()} disabled={myPrptyLstngs.data.loader} text={ method === 'create' ? `Save this property?` : `Update this Property?` }btnText="Confirm"/> }
                    { confirmation.data.hasInvalidInputs && <InputsErrMsg open={confirmation.data.hasInvalidInputs} setOpen={(value) => confirmation.set({ ...confirmation.data, hasInvalidInputs: value })} message="Please complete all required fields with valid information!" ckColor="#d32f2f" bgcolor="#fcd2cf"  /> }
                    { myPrptyLstngs.data.success && <SuccessMsg open={myPrptyLstngs.data.success} setOpen={(v) => myPrptyLstngs.set(p => ({ ...p, success: v }))} message="Success" bgcolor="#d2f9e2" hideDuration={2000}/> }
                </>
            }
        </Box>
    )
}
